import { environment } from 'src/environments/environment';

export interface EndpointRule {
  baseUrl: 'base_url' | 'config_base_url';
  method: string;
  pathPrefix: string;
  requiresAuth: boolean;
}

export const PROTECTED_ENDPOINT_RULES: EndpointRule[] = [
  {
    baseUrl: 'config_base_url',
    method: 'POST',
    pathPrefix: '/api/Configuration/save',
    requiresAuth: true,
  },
  {
    baseUrl: 'config_base_url',
    method: 'GET',
    pathPrefix: '/api/Configuration/ConfigById/',
    requiresAuth: true,
  },
  {
    baseUrl: 'config_base_url',
    method: 'GET',
    pathPrefix: '/api/Configuration/ConfigList/',
    requiresAuth: true,
  },
  {
    baseUrl: 'config_base_url',
    method: 'DELETE',
    pathPrefix: '/api/Configuration/MyAccount',
    requiresAuth: true,
  },
  {
    baseUrl: 'config_base_url',
    method: 'DELETE',
    pathPrefix: '/api/Configuration/',
    requiresAuth: true,
  },
  {
    baseUrl: 'base_url',
    method: 'POST',
    pathPrefix: '/api/AirSimulation/calculate',
    requiresAuth: true,
  },
];

export const ANONYMOUS_ENDPOINT_RULES: EndpointRule[] = [
  {
    baseUrl: 'config_base_url',
    method: 'POST',
    pathPrefix: '/api/Pdf',
    requiresAuth: false,
  },
];

function normalizeMethod(method?: string): string {
  return (method || 'GET').toUpperCase();
}

function normalizeUrl(url: string): string {
  const parsed = new URL(url);
  return parsed.pathname;
}

function normalizeOrigin(url: string): string {
  return new URL(url).origin;
}

function expectedOrigin(baseUrlKey: EndpointRule['baseUrl']): string {
  const baseUrl = environment.caluwin_api[baseUrlKey];
  return new URL(baseUrl).origin;
}

export function matchesRule(url: string, method: string, rule: EndpointRule): boolean {
  const currentMethod = normalizeMethod(method);
  const ruleMethod = normalizeMethod(rule.method);
  const path = normalizeUrl(url);
  const origin = normalizeOrigin(url);

  if (origin !== expectedOrigin(rule.baseUrl)) {
    return false;
  }

  if (ruleMethod !== 'ANY' && ruleMethod !== currentMethod) {
    return false;
  }

  return path.startsWith(rule.pathPrefix);
}

export function isProtectedEndpoint(url: string, method: string): boolean {
  return PROTECTED_ENDPOINT_RULES.some((rule) => matchesRule(url, method, rule));
}

export function isAnonymousEndpoint(url: string, method: string): boolean {
  return ANONYMOUS_ENDPOINT_RULES.some((rule) => matchesRule(url, method, rule));
}
